export enum DisplayType {
  /**
   * @description List 顯示方式(清單)
   */
  LIST = 0,
  /**
   * @description Grid 顯示方式(牌卡)
   */
  GRID = 1,
}
